import { Component, Input, OnInit, inject } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { NotificationSettingsService } from "@app/mailmessages/service/notification-settings.service";
import { TabModel } from "@models/generic/TabModels/TabModel";
import { IdNameCombination } from "@models/generic/IdNameCombination";
import { BaseUserModel } from "../models/base-user-model";
import { firstValueFrom } from "rxjs";

@Component({
    selector: "user-notification-settings",
    templateUrl: "./user-notification-settings.component.html",
    styleUrls: ["./user-notification-settings.component.scss"],
    standalone: false
})
export class UserNotificationSettingsComponent implements OnInit {
    private settingsService = inject(NotificationSettingsService);
    private toastr = inject(ToastrService);

    @Input() parentTab: TabModel;
    @Input() userModel: BaseUserModel;
    @Input() showSave: boolean = true;

    notificationOptions: IdNameCombination[] = [{ ID: 1, Name: "Email" }];
    slackStatusText: string = "Slack not connected";

    async ngOnInit() {
        if (!this.parentTab.showLoader) {
            this.parentTab.showLoader = true;
        }

        if (this.userModel.linkedToSlack) {
            this.notificationOptions = [
                { ID: 1, Name: "Email" },
                { ID: 2, Name: "Slack" },
                { ID: 3, Name: "Both" },
            ];

            this.slackStatusText = "Slack connected";
        }

        this.parentTab.showLoader = false;
    }

    async saveNotificationPreference() {
        await firstValueFrom(
            this.settingsService.storePreference(
                this.userModel.guid,
                this.userModel.notificationPreference
            )
        );
        this.toastr.success("Notification preference saved successfully.");
    }

    async syncUser() {
        await firstValueFrom(this.settingsService.syncUser(this.userModel.guid));
        this.toastr.success("User synced successfully.");
    }
}
